import type { SMPPaymentMethodV2 } from '@viome/viome-base/src/usecase/SMP/SMP.model';
import { PaypalLogo } from './SMPCardBrandLogo';

interface SMPPaypalTileProps {
  paymentMethod: SMPPaymentMethodV2;
  lastChargeDate?: string;
}

export const SMPPaypalTile = ({ paymentMethod, lastChargeDate }: SMPPaypalTileProps) => {
  const { payPal } = paymentMethod;
  if (!payPal) return null;

  return (
    <div
      data-testid="smp-paypalTile"
      className="flex items-center gap-5 rounded-2xl border border-stroke-primary-subtle bg-white p-5"
    >
      <div
        className="flex h-9 w-14 flex-shrink-0 items-center justify-center rounded-md"
        style={{ background: '#FFC439' }}
      >
        <PaypalLogo />
      </div>
      <div className="min-w-0 flex-1">
        <div className="typography-body font-medium text-primary">PayPal</div>
        <div className="typography-caption text-tertiary fs-mask">
          {payPal.email}
          {lastChargeDate ? ` · last charge ${lastChargeDate}` : ''}
        </div>
      </div>
    </div>
  );
};
